import React from 'react';
import { NotifierProvider } from '../../context/NotifierContext';
import ContentRoutes from '../../routes/ContentRoutes';

const Content: React.FC = () => {
  return (
    <div className="relative w-full h-full">
      <NotifierProvider>
        <main className="min-w-0 flex-1 border-t border-gray-200 lg:flex h-full">
          {/* Primary column */}
          <section className="min-w-0 flex-1 h-full flex flex-col overflow-hidden lg:order-last">
            <div className="h-full w-full max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
              <div className="px-4 py-2 sm:px-0">
                {/* <div className="border-4 border-dashed border-gray-200 rounded-lg h-96" /> */}

                <ContentRoutes />
              </div>
            </div>
          </section>
          {/* Secondary column (hidden on smaller screens) */}
          {/* <aside className="hidden lg:block lg:flex-shrink-0 lg:order-first">
          <div className="h-full relative flex flex-col w-96 border-r border-gray-200 bg-gray-100"></div>
        </aside> */}
        </main>
      </NotifierProvider>
    </div>
  );
};

export default Content;
